import React from 'react'
import { Spinner } from 'react-bootstrap'
import { type ExternalUserServiceIntegration } from '../../../../../models/User'
import { DelegatedEmailListItem } from './DelegatedEmailListItem'

export interface DelegatedEmailListProps {
  integrations: ExternalUserServiceIntegration[]
  isFetching: boolean
}

export const DelegatedEmailList = ({ integrations, isFetching }: DelegatedEmailListProps) => {
  if (isFetching) {
    return (
      <div className='d-flex justify-content-center mt-3'>
        <Spinner />
      </div>
    )
  }

  return integrations.length > 0 ? (
    <div className='d-flex flex-column gap-2 w-100'>
      {integrations.map((delegatedEmailIntegration) => (
        <DelegatedEmailListItem key={delegatedEmailIntegration.id} integration={delegatedEmailIntegration} />
      ))}
    </div>
  ) : null
}
